"use client"

import { useState } from "react"

/**
 * State đổi locale RIÊNG trong widget FAQ — không gọi i18n.changeLanguage(),
 * không ảnh hưởng ngôn ngữ toàn trang.
 */
export function useFaqLocale(defaultLocale: string) {
  const [locale, setLocale] = useState(defaultLocale)
  return { locale, setLocale }
}
